import { render, staticRenderFns } from "./MobileAppChat.vue?vue&type=template&id=0b11d3a1&scoped=true&"
import script from "./MobileAppChat.vue?vue&type=script&lang=ts&"
export * from "./MobileAppChat.vue?vue&type=script&lang=ts&"
import style0 from "./MobileAppChat.vue?vue&type=style&index=0&id=0b11d3a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11d3a1",
  null
  
)

export default component.exports